import { render, staticRenderFns } from "./MainLoading.vue?vue&type=template&id=66558fef&scoped=true&"
import script from "./MainLoading.vue?vue&type=script&lang=ts&"
export * from "./MainLoading.vue?vue&type=script&lang=ts&"
import style0 from "./MainLoading.vue?vue&type=style&index=0&id=66558fef&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66558fef",
  null
  
)

export default component.exports